import * as React from 'react';
import { SVGProps } from 'react';

const IconUserSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 13c2.761 0 4.5-2.896 4.5-5.5S16.167 2 12 2 7.5 4.896 7.5 7.5 9.239 13 12 13zm-1 2c-5.5 0-8 2.053-8 8h18c0-6.667-3.5-8-8-8h-2z" />
  </svg>
);
export default IconUserSizeM;
